<template>
  <div v-if="visible" class="act004-m3-mask" @click.stop>
    <div class="act004-m3-panel" @click.stop>
      <button type="button" class="act004-m3-panel__close" @click.stop="requestClose">×</button>
      <div class="act004-m3-panel__body">
        <act004-minigame-match3 :key="'dlg-' + openToken" :config="config" @finish="handleFinish" />
      </div>
    </div>
    <div v-if="showCloseConfirm" class="act004-m3-confirm" role="dialog" aria-modal="true" @click.stop>
      <div class="act004-m3-confirm__card">
        <strong class="act004-m3-confirm__title">确认退出游戏？</strong>
        <p class="act004-m3-confirm__content">退出后本局进度将不会保留。</p>
        <div class="act004-m3-confirm__actions">
          <button type="button" class="act004-m3-confirm__button act004-m3-confirm__button--cancel" @click.stop="cancelClose">继续游戏</button>
          <button type="button" class="act004-m3-confirm__button act004-m3-confirm__button--confirm" @click.stop="confirmClose">退出游戏</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Act004MinigameMatch3 from './Act004MinigameMatch3.vue'

export default {
  name: 'Act004MinigameDialog',
  components: { Act004MinigameMatch3 },
  props: {
    visible: { type: Boolean, default: false },
    config: { type: Object, default: () => ({}) }
  },
  data() {
    return { openToken: 0, gamePlaying: false, confirmingClose: false, showCloseConfirm: false }
  },
  computed: {
    displayTitle() {
      const t = String((this.config && this.config.miniGameTitle) || '').trim()
      return t || '消消乐'
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.openToken += 1
        this.gamePlaying = true
      } else {
        this.gamePlaying = false
        this.confirmingClose = false
        this.showCloseConfirm = false
      }
    }
  },
  methods: {
    handleFinish() {
      this.gamePlaying = false
    },
    requestClose() {
      if (!this.gamePlaying) {
        this.close()
        return
      }
      if (this.confirmingClose) return
      this.confirmingClose = true
      this.showCloseConfirm = true
    },
    cancelClose() {
      this.showCloseConfirm = false
      this.confirmingClose = false
    },
    confirmClose() {
      this.showCloseConfirm = false
      this.confirmingClose = false
      this.close()
    },
    close() {
      this.showCloseConfirm = false
      this.confirmingClose = false
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.act004-m3-mask {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 9800;
  background: rgba(0, 0, 0, 0.62);
  display: flex;
  align-items: center;
  justify-content: center;
}
.act004-m3-panel {
  position: relative;
  width: min(96vw, 560px);
  height: min(90vh, calc(96vw + 140px), 700px);
  background: transparent;
  border-radius: 18px;
  overflow: visible;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 55px rgba(36,30,77,.35);
  transform: translateY(10px);
}
.act004-m3-panel__close {
  position: absolute;
  z-index: 20;
  right: 4px;
  top: -42px;
  width: 32px;
  height: 32px;
  color: #fff;
  font-size: 24px;
  line-height: 26px;
  padding: 0;
  background: rgba(69,58,116,.32);
  border: 1px solid rgba(255,255,255,.48);
  border-radius: 50%;
  cursor: pointer;
}
.act004-m3-panel__body {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  border-radius: 18px;
}
.act004-m3-confirm {
  position: fixed;
  z-index: 30;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(20, 20, 28, .46);
  backdrop-filter: blur(3px);
  animation: act004-m3-confirm-fade .18s ease-out;
}
.act004-m3-confirm__card {
  width: min(76vw, 320px);
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, .72);
  border-radius: 16px;
  background: rgba(255, 255, 255, .96);
  color: #202124;
  text-align: center;
  box-shadow: 0 18px 50px rgba(28, 24, 52, .28);
  animation: act004-m3-confirm-pop .22s cubic-bezier(.2, 1.15, .35, 1);
}
.act004-m3-confirm__title {
  display: block;
  padding: 24px 24px 0;
  font-size: 17px;
  line-height: 24px;
  font-weight: 600;
}
.act004-m3-confirm__content {
  margin: 8px 0 21px;
  padding: 0 24px;
  color: #7b7b80;
  font-size: 14px;
  line-height: 20px;
}
.act004-m3-confirm__actions {
  display: flex;
  height: 52px;
  border-top: 1px solid #e8e8eb;
}
.act004-m3-confirm__button {
  flex: 1;
  margin: 0;
  padding: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
  font-size: 16px;
  line-height: 52px;
  cursor: pointer;
}
.act004-m3-confirm__button + .act004-m3-confirm__button {
  border-left: 1px solid #e8e8eb;
}
.act004-m3-confirm__button--cancel { color: #3c4043; }
.act004-m3-confirm__button--confirm { color: #576bfa; font-weight: 600; }
.act004-m3-confirm__button:active { background: #f3f3f5; }
@keyframes act004-m3-confirm-fade { from { opacity: 0; } }
@keyframes act004-m3-confirm-pop { from { opacity: 0; transform: scale(.9); } }
</style>
